module.exports = __webpack_public_path__ + "static/media/firstscreen.70ce3149.png";